/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Files_TitleInputs */

const en_pc_dl_files_title = /** @type {(inputs: Pc_Dl_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All files`)
};

const zh_pc_dl_files_title = /** @type {(inputs: Pc_Dl_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部文件`)
};

/**
* | output |
* | --- |
* | "All files" |
*
* @param {Pc_Dl_Files_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_files_title = /** @type {((inputs?: Pc_Dl_Files_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Files_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_files_title(inputs)
	return zh_pc_dl_files_title(inputs)
});
export { pc_dl_files_title as "pc.dl.files_title" }